var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 7C17 5.89543 17.8954 5 19 5H25C26.1046 5 27 5.89543 27 7V13C27 14.1046 26.1046 15 25 15H19C17.8954 15 17 14.1046 17 13V7ZM19 6.5H25C25.2761 6.5 25.5 6.72386 25.5 7V13C25.5 13.2761 25.2761 13.5 25 13.5H19C18.7239 13.5 18.5 13.2761 18.5 13V7C18.5 6.72386 18.7239 6.5 19 6.5Z",
    fill: "#383733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 19C17 17.8954 17.8954 17 19 17H25C26.1046 17 27 17.8954 27 19V25C27 26.1046 26.1046 27 25 27H19C17.8954 27 17 26.1046 17 25V19ZM19 18.5H25C25.2761 18.5 25.5 18.7239 25.5 19V25C25.5 25.2761 25.2761 25.5 25 25.5H19C18.7239 25.5 18.5 25.2761 18.5 25V19C18.5 18.7239 18.7239 18.5 19 18.5Z",
    fill: "#383733"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 17C5.89543 17 5 17.8954 5 19V25C5 26.1046 5.89543 27 7 27H13C14.1046 27 15 26.1046 15 25V19C15 17.8954 14.1046 17 13 17H7ZM13.5 19C13.5 18.7239 13.2761 18.5 13 18.5H7C6.72386 18.5 6.5 18.7239 6.5 19V25C6.5 25.2761 6.72386 25.5 7 25.5H13C13.2761 25.5 13.5 25.2761 13.5 25V19Z",
    fill: "#383733"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10ZM10 13.5C8.067 13.5 6.5 11.933 6.5 10C6.5 8.067 8.067 6.5 10 6.5C11.933 6.5 13.5 8.067 13.5 10C13.5 11.933 11.933 13.5 10 13.5Z",
    fill: "#383733"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.9a71de88c84c6a9bc7ea8efc3d899b0e.svg";
export { ForwardRef as ReactComponent };